import { render, staticRenderFns } from "./GeneralSampleInformation.vue?vue&type=template&id=52c51cc6"
import script from "./GeneralSampleInformation.vue?vue&type=script&lang=js"
export * from "./GeneralSampleInformation.vue?vue&type=script&lang=js"
import style0 from "./GeneralSampleInformation.vue?vue&type=style&index=0&id=52c51cc6&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports